module.exports = __webpack_public_path__ + "static/media/how-covid-19-is-changing-food-shopping-twitter-image.cf68fad3.jpg";